import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import moment from "moment";

class Attachment extends Component {
  render() {
    const { src, name, isAgent } = this.props;
    return (
      <Link href={src} isAgent={isAgent} download={name}>
        {name}
      </Link>
    );
  }
}

export default class Bubble extends Component {
  static propType = {
    content: PropTypes.string,
    isAgent: PropTypes.bool,
    timestamp: PropTypes.instanceOf(moment),
    showTimestamp: PropTypes.bool,
  };

  // isUser: PropTypes.bool
  static defaultProps = { isAgent: true };
  render() {
    const { isAgent, showTimestamp, content, mediaList } = this.props;
    const media = mediaList ? mediaList[0] : null;
    let mediaEl = null;
    if (media) {
      if (media.contentType.indexOf("image") >= 0) {
        mediaEl = (
          <a href={media.uri} download={media.fileName}>
            <Media src={media.uri} alt={media.fileName} />
          </a>
        );
      } else {
        mediaEl = (
          <Attachment isAgent={isAgent} src={media.uri} name={media.fileName} />
        );
      }
    }

    return (
      <Wrapper isAgent={isAgent}>
        <BubbleWrapper isAgent={isAgent}>
          <Message>
            <div dangerouslySetInnerHTML={{ __html: content }}></div>
          </Message>
          {mediaEl}
        </BubbleWrapper>
        {showTimestamp ? (
          <SendTime>{this.props.timestamp.format("MMM D hh:mm A")}</SendTime>
        ) : (
          ""
        )}
      </Wrapper>
    );
  }
}
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 10px;
  align-items: ${(props) => (props.isAgent ? "flex-start" : "flex-end")};
`;

const BubbleWrapper = styled.div`
  display: flex;
  min-height: 20px;
  padding: 10px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  flex-direction: column;
  ${(props) =>
    props.isAgent &&
    css`
      border-bottom-right-radius: 15px;
      background-color: #edf0f5;
      color: #4d4f5c;
      align-items: flex-start;
      text-align: left;
    `};
  ${(props) =>
    !props.isAgent &&
    css`
      border-bottom-left-radius: 20px;
      background-color: #1e5271;
      color: #ffffff;
      align-items: flex-end;
      text-align: right;
    `};
`;

const Message = styled.div`
  font-size: 12px;
  font-family: "Source Sans Pro", sans-serif;
  font-style: regular;
  line-height: 1.5;
  min-width: 20%;
`;

const SendTime = styled.span`
  font-size: 10px;
  margin-top: 3px;
  margin-bottom: 3px;
  font-family: "Source Sans Pro", sans-serif;
  font-style: Regular;
  color: #a9a8b5;
`;

const Media = styled.img`
  width: 50%;
`;

const Link = styled.a`
  color: white;
  font-size: 12px;
  ${(props) =>
    props.isAgent &&
    css`
      color: blueviolet;
    `}
`;
